import React from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import Layout from "../layout";

const TourGuideBrochure = () => {
    const me = useSelector(state => state.API.me);

    return (
        <Layout selected="tourguide">
            <div className="brochure-page" style={{ maxWidth: '800px', margin: '0 auto', padding: '2rem 1rem' }}>
                <nav aria-label="breadcrumb" className="breadcrumb-nav">
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item">
                            <Link to="/">Home</Link>
                        </li>
                        <li className="breadcrumb-item active">Become a Guide</li>
                    </ol>
                </nav>

                <div className="text-center mb-5">
                    <h1 style={{ fontSize: '2.5rem', marginBottom: '1rem' }}>Share Your World</h1>
                    <p className="lead text-muted" style={{ maxWidth: '600px', margin: '0 auto' }}>
                        Turn your local knowledge into unforgettable experiences for travelers from around the world.
                    </p>
                </div>

                <div className="row mb-5">
                    <div className="col-md-4 text-center mb-4">
                        <div className="feature-icon mb-3">
                            <i className="bi bi-calendar-check" style={{ fontSize: '2.5rem', color: '#e17055' }}></i>
                        </div>
                        <h4>Publish Anytime</h4>
                        <p className="text-muted">Create tours and add stops whenever you want. Update content as your city changes.</p>
                    </div>
                    <div className="col-md-4 text-center mb-4">
                        <div className="feature-icon mb-3">
                            <i className="bi bi-cash-stack" style={{ fontSize: '2.5rem', color: '#e17055' }}></i>
                        </div>
                        <h4>Earn Money</h4>
                        <p className="text-muted">Earn royalties when listeners spend time with your tours.</p>
                    </div>
                    <div className="col-md-4 text-center mb-4">
                        <div className="feature-icon mb-3">
                            <i className="bi bi-people" style={{ fontSize: '2.5rem', color: '#e17055' }}></i>
                        </div>
                        <h4>Meet People</h4>
                        <p className="text-muted">Connect with travelers from around the world and share your passion for your city.</p>
                    </div>
                </div>

                <div className="bg-light rounded p-4 mb-5">
                    <h2 className="mb-4">How It Works</h2>
                    
                    <div className="d-flex mb-4">
                        <div className="step-number me-3" style={{ 
                            width: '40px', 
                            height: '40px', 
                            borderRadius: '50%', 
                            background: '#e17055', 
                            color: 'white',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontWeight: 'bold',
                            flexShrink: 0
                        }}>1</div>
                        <div>
                            <h5 className="mb-1">Create Your Profile</h5>
                            <p className="text-muted mb-0">Sign up and tell visitors about yourself, your background, and what makes you unique.</p>
                        </div>
                    </div>

                    <div className="d-flex mb-4">
                        <div className="step-number me-3" style={{ 
                            width: '40px', 
                            height: '40px', 
                            borderRadius: '50%', 
                            background: '#e17055', 
                            color: 'white',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontWeight: 'bold',
                            flexShrink: 0
                        }}>2</div>
                        <div>
                            <h5 className="mb-1">Design Your Tours</h5>
                            <p className="text-muted mb-0">Create tours that showcase what you love about your city. Add photos, descriptions, and audio stops.</p>
                        </div>
                    </div>

                    <div className="d-flex mb-4">
                        <div className="step-number me-3" style={{ 
                            width: '40px', 
                            height: '40px', 
                            borderRadius: '50%', 
                            background: '#e17055', 
                            color: 'white',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontWeight: 'bold',
                            flexShrink: 0
                        }}>3</div>
                        <div>
                            <h5 className="mb-1">Publish & Grow</h5>
                            <p className="text-muted mb-0">Publish your tour and keep improving it over time as listeners explore your city.</p>
                        </div>
                    </div>
                </div>

                <div className="text-center py-4">
                    <h3 className="mb-4">Ready to Get Started?</h3>
                    {me ? (
                        <div className="d-flex flex-column gap-3 align-items-center">
                            <Link to="/tourguide/edit" className="btn-primary">
                                <i className="bi bi-person-plus me-2"></i>Create Your Profile
                            </Link>
                            <span className="text-muted">or</span>
                            <Link to="/tourguide" className="btn-outline">
                                Go to Dashboard
                            </Link>
                        </div>
                    ) : (
                        <div className="d-flex flex-column gap-3 align-items-center">
                            <p className="text-muted">Create an account to start your journey as a guide.</p>
                            <Link to="/signup" className="btn-primary">
                                Sign Up Now
                                <i className="bi bi-arrow-right ms-2"></i>
                            </Link>
                        </div>
                    )}
                </div>

                <hr className="my-5" />

                <div className="mb-4">
                    <h3 className="mb-3">Our Promise</h3>
                    <div className="row">
                        <div className="col-md-6 mb-3">
                            <div className="d-flex align-items-start">
                                <i className="bi bi-check-circle-fill text-success me-2" style={{ marginTop: '3px' }}></i>
                                <div>
                                    <strong>No Hidden Fees</strong>
                                    <p className="text-muted small mb-0">Simple subscription access for listeners and transparent royalty payouts for guides.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 mb-3">
                            <div className="d-flex align-items-start">
                                <i className="bi bi-check-circle-fill text-success me-2" style={{ marginTop: '3px' }}></i>
                                <div>
                                    <strong>You're In Control</strong>
                                    <p className="text-muted small mb-0">Publish tours, update content anytime, and build your audience.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 mb-3">
                            <div className="d-flex align-items-start">
                                <i className="bi bi-check-circle-fill text-success me-2" style={{ marginTop: '3px' }}></i>
                                <div>
                                    <strong>Easy Tools</strong>
                            <p className="text-muted small mb-0">Simple tools to publish tours, manage stops, and grow your audience.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 mb-3">
                            <div className="d-flex align-items-start">
                                <i className="bi bi-check-circle-fill text-success me-2" style={{ marginTop: '3px' }}></i>
                                <div>
                                    <strong>Global Reach</strong>
                                    <p className="text-muted small mb-0">Connect with travelers searching for authentic local experiences.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    );
}

export default TourGuideBrochure;
